import { APP_CONFIG } from "app.config";
import { ICustomRendererGroup } from "./ag-grid-group.interface";
import { UtilCommon } from "app/shared/common/utils/UtilCommon";

const AGGRID_GROUP_API = Object.freeze({
    API_PAGING: `${APP_CONFIG.MCRHRC}md/vHrtbCompany/pivotPaging`,
    API_COUNT: `${APP_CONFIG.MCRHRC}md/vHrtbCompany/pivotCount`
});


export function extractUsername(emails) {
    if (emails?.length === 0) return [];
    const regex = /(.+?)@/;
    return emails.map(email => {
        const match = regex.exec(email?.trim());
        return match ? match[1] : null;
    });
}

const MIN_LENGTH_TEXT_SEARCH = 1;

const DEFAULT_CUSTOM_RENDERER_GROUP: ICustomRendererGroup = {
    "handleBy": (params) => {
        if (!params || !params?.value) {
            // return "undefined ";
            return " ";
        }

        let value = extractUsername(UtilCommon.deepClone(params.value?.split(',')));
        // return value?.length ? value?.[0] : "undefined";
        return value?.length ? value?.[0] : "";
    },
}

export {
    MIN_LENGTH_TEXT_SEARCH,
    AGGRID_GROUP_API,
    DEFAULT_CUSTOM_RENDERER_GROUP
}


export const RequestDefault = [
    {
      id: "record_count",
      aggFunc: "count",
      displayName: "Record Count",
      field: "id",
    },
    {
      id: "no_of_request",
      aggFunc: "sum",
      displayName: "noOfRequest Sum",
      field: "noOfRequest",
    },
    {
      id: "remain_by_rr",
      aggFunc: "sum",
      displayName: "remainByRr Sum",
      field: "remainByRr",
    },
    {
      id: "remain",
      aggFunc: "sum",
      displayName: "remainSum Sum",
      field: "remain",
    },
    {
      id: "no_of_recruited",
      aggFunc: "sum",
      displayName: "noOfRecruitedSum Sum",
      field: "noOfRecruited",
    },
    {
      "id": "remain_Level1_Sum",
      "aggFunc": "sum",
      "displayName": "remainLevel1 Sum",
      "field": "remainLevel1"
    },
    {
      "id": "remain_Level2_Sum",
      "aggFunc": "sum",
      "displayName": "remainLevel2 Sum",
      "field": "remainLevel2"
    },
    {
      "id": "remain_Level3_Sum",
      "aggFunc": "sum",
      "displayName": "remainLevel3 Sum",
      "field": "remainLevel3"
    },
    {
      "id": "remain_Level0_Sum",
      "aggFunc": "sum",
      "displayName": "remainLevel0 Sum",
      "field": "remainLevel0"
    }
  ];